var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-centered"},[_c('img',{staticClass:"logo-image",attrs:{"src":"/img/logo.png","alt":"logo"}})])
}]

export { render, staticRenderFns }